// extracted by mini-css-extract-plugin
export default {"center":"cNxhE"};